
import { NoteModel } from '@/models/student-notes/note.model';
import Vue from 'vue';
import { secondsToTimestamp } from '@/helpers/date';
import { AnnotationInputCard } from '@descomplica/vue-components';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

interface Data {
  resizedVideoNotes: NoteModel[];
  swiperOption: { pagination: Object };
}

interface GroupNotes {
  [id: number]: { percent: number; items: NoteModel[] };
}

export default Vue.extend({
  components: {
    AnnotationInputCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    videoNotes: {
      type: Array as Vue.PropType<NoteModel[]>,
      required: true,
    },
    videoDuration: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      resizedVideoNotes: [] as NoteModel[],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    };
  },
  computed: {
    offsetWidthNotes(): number {
      return (this.$refs.notesTimelinePlayer as HTMLElement)?.offsetWidth || 0;
    },
    groupNotesList(): GroupNotes[] {
      const groupNotesObject = this.resizedVideoNotes.reduce(
        (groupNotes: GroupNotes, item: NoteModel) => {
          const percent = Math.floor(
            this.convertInPercent(item.videoTimeStamp, this.videoDuration),
          );
          const items = groupNotes[percent]?.items || [];
          items.push(item);

          return {
            ...groupNotes,
            [percent]: {
              items,
              percent,
            },
          };
        },
        {},
      );
      return Object.values(groupNotesObject);
    },
  },
  watch: {
    videoNotes(value: NoteModel[]) {
      this.resizedVideoNotes = value;
    },
  },
  mounted() {
    this.resizedVideoNotes = this.videoNotes;
  },
  methods: {
    getSecondsToTimestamp(seconds: number) {
      return secondsToTimestamp(seconds);
    },
    convertInPercent(videoTimeStamp: number, videoDuration: number) {
      return (videoTimeStamp / videoDuration) * 100;
    },
    convertInPixel(percent: number, total: number) {
      const halfSizeOfCard = 164;

      if ((percent * total) / 100 - halfSizeOfCard < 0)
        return {
          left: `${
            (percent * total) / 100 -
            (halfSizeOfCard + 10) -
            ((percent * total) / 100 - halfSizeOfCard)
          }px`,
        };

      if ((percent * total) / 100 + halfSizeOfCard > total)
        return { left: `calc(100% - ${(percent * total) / 100 - (total - halfSizeOfCard * 2)}px)` };

      return { right: `${-halfSizeOfCard}px` };
    },
  },
});
